import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Typography, Button } from '@mui/material';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { Link as RouterLink } from 'react-router-dom';
import { colors } from '../../football/colors';

/** ARCHIVE-1: static stand-in for every formerly-live surface (schedule,
 * live match, standings, knockouts, match detail, upsets). The backend is
 * decommissioned, so these views can never load again — instead of a 502
 * they say the tournament is over and point at the archived Track Record.
 *
 * `standalone` wraps the notice in its own page container + Helmet for
 * routes that render outside WorldCup2026Layout (/football/match/:id,
 * /football/upsets).
 */
const TournamentCompletePage: React.FC<{ standalone?: boolean }> = ({
  standalone = false,
}) => {
  const body = (
    <Box data-testid="tournament-complete" sx={{ textAlign: 'center', py: 8 }}>
      <EmojiEventsIcon sx={{ fontSize: 48, color: colors.homeAccent, mb: 1 }} />
      <Typography
        variant="h5"
        sx={{ fontWeight: 800, color: colors.textPrimary, mb: 1 }}
      >
        FIFA World Cup 2026 has concluded
      </Typography>
      <Typography variant="body1" sx={{ color: colors.labelText, mb: 3 }}>
        Spain won the Final against Argentina in extra time on July 19, 2026.
        Live coverage has ended — the full prediction record is preserved.
      </Typography>
      <Button
        variant="contained"
        component={RouterLink}
        to="/football/world-cup-2026/track-record"
      >
        View the final Track Record
      </Button>
    </Box>
  );

  if (!standalone) return body;

  return (
    <>
      <Helmet>
        <title>FIFA World Cup 2026 — Tournament Concluded | FantasyFuel</title>
        <meta
          name="description"
          content="The FIFA World Cup 2026 has concluded. View the final archived prediction track record."
        />
      </Helmet>
      <Box sx={{ maxWidth: 700, mx: 'auto', px: { xs: 1, sm: 2 }, py: 3 }}>
        {body}
      </Box>
    </>
  );
};

export default TournamentCompletePage;
